import { render } from "./PlanCourseware.vue?vue&type=template&id=9ec65740&scoped=true"
import script from "./PlanCourseware.vue?vue&type=script&lang=js"
export * from "./PlanCourseware.vue?vue&type=script&lang=js"

import "./PlanCourseware.vue?vue&type=style&index=0&id=9ec65740&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9ec65740"

export default script